export default "__VITE_ASSET__B9tRUyi5__"